/**
 * useBp — the landing's three layout breakpoints, read synchronously so the
 * first render already uses the right pass scale (no flash on load).
 *   'm' ≤600px · 't' ≤980px · 'd' wider   (same as the mockup's slotScale())
 */
import { useSyncExternalStore } from 'react';

const Q_M = '(max-width: 600px)';
const Q_T = '(max-width: 980px)';

function read() {
  if (typeof window === 'undefined' || !window.matchMedia) return 'd';
  if (window.matchMedia(Q_M).matches) return 'm';
  if (window.matchMedia(Q_T).matches) return 't';
  return 'd';
}

function subscribe(cb) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => {};
  const mqs = [window.matchMedia(Q_M), window.matchMedia(Q_T)];
  mqs.forEach((mq) => mq.addEventListener?.('change', cb));
  return () => mqs.forEach((mq) => mq.removeEventListener?.('change', cb));
}

export default function useBp() {
  return useSyncExternalStore(subscribe, read, () => 'd');
}
